import React from 'react';
import { CheckIcon, UsersIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { PRECIOS, RESERVA_LINK } from '../../data/retiro';
export function Inversion() {
  return <section id="inversion" className="relative w-full overflow-hidden px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'var(--ink)'
  }} data-id="element-109">
      <div className="mx-auto max-w-5xl" data-id="element-110">
        <SectionHeading eyebrow="Inversión" title="Tu transformación comienza con un SÍ" light data-id="element-111" />

        <div className="mt-16 grid gap-6 md:grid-cols-3" data-id="element-112">
          {PRECIOS.map((p, i) => <Reveal key={p.concepto} delay={i * 0.1} data-id="element-113">
              <div className="flex h-full flex-col rounded-3xl border border-white/10 bg-white/[0.04] p-8 text-center" data-id="element-114">
                <span className="text-3xl" data-id="element-115">{p.emoji}</span>
                <p className="mt-4 text-sm uppercase tracking-wide text-white/60" data-id="element-116">
                  {p.concepto}
                </p>
                <p className="mt-2 font-heading text-3xl font-light" style={{
              color: 'var(--jasmine)'
            }} data-id="element-117">
                  {p.valor}
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.15} data-id="element-118">
          <div className="mt-8 flex flex-col items-center gap-3 rounded-3xl p-8 text-center" style={{
          backgroundColor: 'var(--darkgoldenrod)'
        }} data-id="element-119">
            <span className="text-sm font-medium uppercase tracking-[0.2em] text-white/80" data-id="element-120">
              🎁 Oferta especial · Pago total adelantado
            </span>
            <p className="font-heading text-4xl font-light text-white" data-id="element-121">
              3.000 USD
            </p>
            <p className="text-sm text-white/85" data-id="element-122">
              Precio válido hasta el 15 de julio.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-123">
          <div className="mt-10 flex flex-col items-center gap-6" data-id="element-124">
            <p className="inline-flex items-center gap-2 text-sm text-white/70" data-id="element-125">
              <UsersIcon className="h-4 w-4" style={{
              color: 'var(--jasmine)'
            }} data-id="element-126" />
              🚨 Capacidad máxima: 13 personas · Cupos limitados
            </p>
            <a href="https://tienda.espacioparaelalma.com/p/retiro-bali-reserva" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full px-10 py-4 text-sm font-medium transition-transform hover:scale-[1.04]" style={{
            backgroundColor: 'var(--jasmine)',
            color: 'var(--ink)'
          }} data-id="element-127">
              <CheckIcon className="h-4 w-4" data-id="element-128" />
              Reservar con separación de 333 USD
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}